import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import { Button, Col, Collapse, Form, InputGroup, Modal, Spinner, Table, Toast, ToastContainer } from "react-bootstrap";
import { BsFillArrowRightCircleFill } from "react-icons/bs";
import { EngagementAnswerData, EngagementItemData, ProductsStrings } from "../../../../business/core";
import { EngagementListPageControllerImpl } from "../../../../business/impl";

export const EngagementList: React.FC<{ data: EngagementItemData[] }> = ({ data }) => {
    const strings = ProductsStrings["PTBR"].products;
    const [engagementData, setEngagementData] = useState<EngagementItemData[]>(data);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
    const [showModal, setShowModal] = useState(false);
    const [validated, setValidated] = useState(false);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [toast, setToast] = useState<string>('');
    const [toastType, setToastType] = useState<string>('success');
    const [selectedQuantity, setSelectedQuantity] = useState<number>(1);

    const [engagementSelected, setEngagementSelected] = useState<EngagementItemData>(data[0]);
    const [radioSelected, setRadioSelected] = useState<null | string>(null);
    const [soldValue, setSoldValue] = useState(1);

    function decrypt(encryptedText, key = '!!!@!#!$!%') {
        return encryptedText;
    }

    const controller = new EngagementListPageControllerImpl();

    const handleIncrease = () => {
        if (selectedQuantity > soldValue) {
            setSoldValue((prevValue) => prevValue + 1);
        }
    };

    const handleDecrease = () => {
        setSoldValue((prevValue) => (prevValue > 1 ? prevValue - 1 : 1));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        setLoading(true);
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            setLoading(false);
        } else {
            const dataToContinue: EngagementAnswerData = { chosen: `${radioSelected}.${engagementSelected.id}`, quantity: soldValue };
            try {
                const response = await controller.answerEngagement(dataToContinue);
                setToastType('success');
                setToast(response.description);
                setEngagementData(response.data);
            } catch (error) {
                setToastType('danger');
                setToast(error.toString());
            }
            setShowModal(false);
            setLoading(false);
        }
    };

    const handleListItem = (item: EngagementItemData) => {
        if (item.status !== 'SOLD' && item.status !== 'CLOSED') {
            setRadioSelected(null);
            setSelectedQuantity(item.quantity);
            setEngagementSelected(item);
            setShowModal(true);
        }
    }

    useEffect(() => {
        window.addEventListener(
            "resize",
            () => {
                const ismobile = window.innerWidth < 992;
                if (ismobile !== isMobile) setIsMobile(ismobile);
            },
            false
        );
    }, [isMobile]);

    useEffect(() => {
        if (selectedQuantity < soldValue) {
            setSoldValue(selectedQuantity);
        } else if (soldValue < 1) {
            setSoldValue(1);
        }
    }, [selectedQuantity, soldValue]);

    return (
        <>
            <Table responsive striped hover>
                <thead>
                    <tr>
                        <th></th>
                        <th>{strings.engagementTable.interestedName}</th>
                        <th>{strings.engagementTable.carPartName}</th>
                        <th>{strings.engagementTable.date}</th>
                        <th>{strings.engagementTable.status}</th>
                    </tr>
                </thead>
                <tbody>
                    {engagementData.map((item) => (
                        <tr
                            key={item.id}
                            style={item.status !== "SOLD" && item.status !== "CLOSED" ? { whiteSpace: "nowrap", cursor: "pointer" } : {}}
                            onClick={() => handleListItem(item)}>
                            <td>{item.status !== "SOLD" && item.status !== "CLOSED" ? <BsFillArrowRightCircleFill /> : null}</td>
                            <td>{item.interested}</td>
                            <td>{item.car_part}</td>
                            <td>{item.date}</td>
                            <td className={item.status === "CONTACTED" ? "bg-danger" : ""}>
                                {strings.engagementTable.currentStatus[item.status]}
                            </td>
                        </tr>)
                    )}
                </tbody>
            </Table >
            <Modal
                show={showModal}
                onHide={() => setShowModal(isLoading)}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header closeButton>
                    <Modal.Title>{strings.engagementListPage.modal.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body
                    className="bg-dark text-white">
                    <Form noValidate validated={validated} onSubmit={handleSubmit}>
                        <fieldset disabled={isLoading}>
                            <Form.Group className="mb-3">
                                {engagementSelected.status !== 'CONTACTED' ?
                                    <Form.Check
                                        label={strings.engagementListPage.modal.options.seeUserDataLabel}
                                        name="group1"
                                        type={"radio"}
                                        className="mb-3"
                                        onChange={() => setRadioSelected('SEND_USER_DATA')}
                                    /> : null}
                                {
                                    engagementSelected.status === 'CONTACTED' ?
                                        <>
                                            <Form.Check
                                                label={strings.engagementListPage.modal.options.itemSold.label}
                                                name="group1"
                                                type={"radio"}
                                                className="mb-3"
                                                onChange={() => setRadioSelected('SOLD_CAR_PART')}
                                            />
                                            <Collapse className="mb-4" in={radioSelected === "SOLD_CAR_PART" && selectedQuantity > 1}>
                                                <Form.Group as={Col} md={3}>
                                                    {strings.engagementListPage.modal.options.itemSold.howManyItensText}

                                                    <InputGroup>
                                                        <Button variant="outline-secondary" onClick={handleDecrease}>
                                                            -
                                                        </Button>
                                                        <Form.Control
                                                            type="number"
                                                            value={soldValue}
                                                            onChange={(e) => setSoldValue(Number(e.target.value))}
                                                            min={1}
                                                            max={selectedQuantity}
                                                            step={1}
                                                            className="text-center"
                                                        />
                                                        <Button variant="outline-secondary" onClick={handleIncrease}>
                                                            +
                                                        </Button>
                                                    </InputGroup>
                                                </Form.Group>
                                            </Collapse>
                                        </>
                                        : null
                                }
                                <Form.Check
                                    label={strings.engagementListPage.modal.options.noAgreement}
                                    name="group1"
                                    type={"radio"}
                                    className="mb-3"
                                    onChange={() => setRadioSelected('NO_NEGOTIATION')}
                                />
                            </Form.Group>
                            <div className="d-grid gap-2 mt-5">
                                <Button type="submit" variant="primary" size="lg" disabled={radioSelected === null}>
                                    {isLoading ? <Spinner /> : strings.engagementListPage.modal.continueButton}
                                </Button>
                            </div>
                        </fieldset>
                    </Form>
                </Modal.Body>
            </Modal>
            <ToastContainer
                className="p-3"
                position={'top-end'}
                style={{ zIndex: 1 }}
            >
                <Toast onClose={() => setToast('')} show={toast !== ''} delay={7000} bg={toastType} autohide>
                    <Toast.Header>
                        <strong className="me-auto">Montacar</strong>
                    </Toast.Header>
                    <Toast.Body className={'text-white'}>{toast}</Toast.Body>
                </Toast>
            </ToastContainer>
        </>
    );
}
